// import axios from 'axios';

// import { AUTHORIZATION_PATH } from '@app/constants';
// import { disconnectSignalR } from '@app/utils';
// import { clearBrowserStorageCompletely } from '@app/utils/clearBrowserStorageCompletely';
// import { resetReduxStateFull } from '@app/utils/resetReduxStateFull';

// export const logOutUser = async (): Promise<void> => {
//   try {
//     await disconnectSignalR();

//     delete axios.defaults.headers.common.Authorization;

//     await clearBrowserStorageCompletely();

//     await resetReduxStateFull();
//   } catch (err) {
//   } finally {
//     window.location.replace(AUTHORIZATION_PATH);
//   }
// };
import axios from 'axios';
import Cookies from 'js-cookie';

import {
  AUTHORIZATION_PATH,
  BY_HELP_AUTH,
  DEV_BY_HELP_AUTH,
  PROD_MODE,
} from '@app/constants';
import {
  clearActiveBranchSession,
  defineDeployingMode,
  clearBrowserStorage,
  disconnectSignalR,
  hardResetRedux,
} from '@app/utils';

export const logOutUser = async (): Promise<void> => {
  const cookieName =
    defineDeployingMode(window.location.host) === PROD_MODE
      ? BY_HELP_AUTH
      : DEV_BY_HELP_AUTH;
  Cookies.remove(cookieName);

  delete axios.defaults.headers.common.Authorization;

  clearActiveBranchSession();

  await clearBrowserStorage();
  disconnectSignalR();

  await hardResetRedux();

  window.location.replace(AUTHORIZATION_PATH);
};
